import { render, staticRenderFns } from "./reduceSamplePopup.vue?vue&type=template&id=ccfe65d6&scoped=true&"
import script from "./reduceSamplePopup.vue?vue&type=script&lang=js&"
export * from "./reduceSamplePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfe65d6",
  null
  
)

export default component.exports